export default __webpack_public_path__ + "static/media/Empty-notif.a2ada31f.svg";